/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../html-utils/element-width.directive';
import * as import2 from '../../orchestration/responsive.service';
import * as import3 from '../../orchestration/responsive.directive';
import * as import4 from '../../orchestration/navigation.service';
import * as import5 from '../../promo/promo-card/promo-card.component.ngfactory';
import * as import6 from '../../promo/promo-card/promo-card.component';
import * as import7 from '../../orchestration/analytics.service';
import * as import8 from 'ng2-translate/src/translate.service';
import * as import9 from '../../orchestration/session.model';
import * as import10 from '../../menu/menu.model';
import * as import11 from '../../promo/promo.model';
import * as import12 from '../deal.model';
import * as import13 from '@angular/common';
import * as import14 from 'ng2-translate/src/translate.pipe';
import * as import15 from '../../ui-elements/touchable.directive';
import * as import16 from './deals-page.component';
import * as import17 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import18 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import19 from '../../orchestration/page';
import * as import20 from '../../buttons/button/button.component.ngfactory';
import * as import21 from '../../buttons/button/button.component';
import * as import22 from '../../page-layout/page-footer-control.directive';
import * as import23 from '../../ordering-context/ordering-context.model';
import * as import24 from '../../identity/identity.model';
import * as import25 from '@fedelta-pos/data-client/auth/auth.service';
import * as import26 from '../../ui-elements/loading/loading.service';
import * as import27 from '../../notification/notification.service';
const styles_DealsPageComponent:any[] = ([] as any[]);
export const RenderType_DealsPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_DealsPageComponent,
  data: {}
}
);
function View_DealsPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[
      [
        'class',
        'deals-deal'
      ]
      ,
      [
        'woa-element-width',
        ''
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(5455872,(null as any),0,import1.ElementWidthDirective,[
      import0.ElementRef,
      import0.ChangeDetectorRef,
      import2.ResponsiveService
    ]
    ,(null as any),(null as any)),
    import0.ɵdid(737280,(null as any),0,import3.ResponsiveDirective,[
      import0.ElementRef,
      import2.ResponsiveService,
      import4.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-promo-card',([] as any[]),[
      [
        2,
        'inlineAction',
        (null as any)
      ]
      ,
      [
        2,
        'cornerAction',
        (null as any)
      ]
      ,
      [
        2,
        'peelAction',
        (null as any)
      ]
      ,
      [
        2,
        'bottomDescription',
        (null as any)
      ]
      ,
      [
        2,
        'fadeOut',
        (null as any)
      ]
      ,
      [
        2,
        'withAction',
        (null as any)
      ]
      ,
      [
        2,
        'typeSpecific',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.login()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import5.View_PromoCardComponent_0,import5.RenderType_PromoCardComponent)),
    import0.ɵdid(245760,(null as any),0,import6.PromoCardComponent,[
      import4.NavigationService,
      import7.AnalyticsService,
      import0.ElementRef,
      import8.TranslateService,
      import9.SessionModel,
      import10.MenuModel,
      import11.PromoModel,
      import12.DealModel,
      import0.ChangeDetectorRef
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      message: [
        1,
        'message'
      ]
      ,
      image: [
        2,
        'image'
      ]
      ,
      autoCropImage: [
        3,
        'autoCropImage'
      ]
      ,
      actionLabel: [
        4,
        'actionLabel'
      ]

    }
    ,{onActivate: 'onActivate'}),
    import0.ɵpid(131072,import13.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import13.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import13.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import13.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import14.TranslatePipe,[
      import8.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    ck(v,1,0);
    ck(v,2,0);
    var tmp_7_0:any = (null as any);
    const currVal_7:any = (((tmp_7_0 = import0.ɵunv(v,5,0,import0.ɵnov(v,6).transform(co.SessionEvents.currentApp$))) == null)? (null as any): tmp_7_0.promoteMemberLoginText1);
    var tmp_8_0:any = (null as any);
    const currVal_8:any = (((tmp_8_0 = import0.ɵunv(v,5,1,import0.ɵnov(v,7).transform(co.SessionEvents.currentApp$))) == null)? (null as any): tmp_8_0.promoteMemberLoginText2);
    var tmp_9_0:any = (null as any);
    const currVal_9:any = (((tmp_9_0 = import0.ɵunv(v,5,2,import0.ɵnov(v,8).transform(co.SessionEvents.currentApp$))) == null)? (null as any): tmp_9_0.promoteMemberLoginImage);
    var tmp_10_0:any = (null as any);
    const currVal_10:any = (((tmp_10_0 = import0.ɵunv(v,5,3,import0.ɵnov(v,9).transform(co.SessionEvents.currentApp$))) == null)? (null as any): tmp_10_0.promoteMemberLoginImageAutoCrop);
    const currVal_11:any = import0.ɵunv(v,5,4,import0.ɵnov(v,10).transform('woa.common.login'));
    ck(v,5,0,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,5).inlineAction;
    const currVal_1:any = import0.ɵnov(v,5).cornerAction;
    const currVal_2:any = import0.ɵnov(v,5).peelAction;
    const currVal_3:any = import0.ɵnov(v,5).bottomDescription;
    const currVal_4:any = import0.ɵnov(v,5).fadeOut;
    const currVal_5:any = import0.ɵnov(v,5).withAction;
    const currVal_6:any = import0.ɵnov(v,5).currentRestrictedOrderTypes;
    ck(v,4,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_DealsPageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'deals-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵpid(131072,import14.TranslatePipe,[
      import8.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.heading.deals.memberDeals'));
    ck(v,1,0,currVal_0);
  });
}
function View_DealsPageComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[
      [
        'class',
        'deals-deal'
      ]
      ,
      [
        'woa-element-width',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(5455872,(null as any),0,import1.ElementWidthDirective,[
      import0.ElementRef,
      import0.ChangeDetectorRef,
      import2.ResponsiveService
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-promo-card',([] as any[]),[
      [
        8,
        'id',
        0
      ]
      ,
      [
        2,
        'inlineAction',
        (null as any)
      ]
      ,
      [
        2,
        'cornerAction',
        (null as any)
      ]
      ,
      [
        2,
        'peelAction',
        (null as any)
      ]
      ,
      [
        2,
        'bottomDescription',
        (null as any)
      ]
      ,
      [
        2,
        'fadeOut',
        (null as any)
      ]
      ,
      [
        2,
        'withAction',
        (null as any)
      ]
      ,
      [
        2,
        'typeSpecific',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.orderDeal(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import5.View_PromoCardComponent_0,import5.RenderType_PromoCardComponent)),
    import0.ɵdid(245760,(null as any),0,import6.PromoCardComponent,[
      import4.NavigationService,
      import7.AnalyticsService,
      import0.ElementRef,
      import8.TranslateService,
      import9.SessionModel,
      import10.MenuModel,
      import11.PromoModel,
      import12.DealModel,
      import0.ChangeDetectorRef
    ]
    ,{
      showCodeLink: [
        0,
        'showCodeLink'
      ]
      ,
      deal: [
        1,
        'deal'
      ]

    }
    ,{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    ck(v,1,0);
    const currVal_8:any = true;
    const currVal_9:any = v.context.$implicit;
    ck(v,4,0,currVal_8,currVal_9);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'member-deal-',v.context.index,'');
    const currVal_1:any = import0.ɵnov(v,4).inlineAction;
    const currVal_2:any = import0.ɵnov(v,4).cornerAction;
    const currVal_3:any = import0.ɵnov(v,4).peelAction;
    const currVal_4:any = import0.ɵnov(v,4).bottomDescription;
    const currVal_5:any = import0.ɵnov(v,4).fadeOut;
    const currVal_6:any = import0.ɵnov(v,4).withAction;
    const currVal_7:any = import0.ɵnov(v,4).currentRestrictedOrderTypes;
    ck(v,3,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_DealsPageComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'deals-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵpid(131072,import14.TranslatePipe,[
      import8.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform((co.memberDeals.length? 'woa.heading.deals.appDeals.withMemberDeals': 'woa.heading.deals.appDeals.withoutMemberDeals')));
    ck(v,1,0,currVal_0);
  });
}
function View_DealsPageComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[
      [
        'class',
        'deals-deal'
      ]
      ,
      [
        'woa-element-width',
        ''
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(5455872,(null as any),0,import1.ElementWidthDirective,[
      import0.ElementRef,
      import0.ChangeDetectorRef,
      import2.ResponsiveService
    ]
    ,(null as any),(null as any)),
    import0.ɵdid(737280,(null as any),0,import3.ResponsiveDirective,[
      import0.ElementRef,
      import2.ResponsiveService,
      import4.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-promo-card',([] as any[]),[
      [
        8,
        'id',
        0
      ]
      ,
      [
        2,
        'inlineAction',
        (null as any)
      ]
      ,
      [
        2,
        'cornerAction',
        (null as any)
      ]
      ,
      [
        2,
        'peelAction',
        (null as any)
      ]
      ,
      [
        2,
        'bottomDescription',
        (null as any)
      ]
      ,
      [
        2,
        'fadeOut',
        (null as any)
      ]
      ,
      [
        2,
        'withAction',
        (null as any)
      ]
      ,
      [
        2,
        'typeSpecific',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.orderDeal(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import5.View_PromoCardComponent_0,import5.RenderType_PromoCardComponent)),
    import0.ɵdid(245760,(null as any),0,import6.PromoCardComponent,[
      import4.NavigationService,
      import7.AnalyticsService,
      import0.ElementRef,
      import8.TranslateService,
      import9.SessionModel,
      import10.MenuModel,
      import11.PromoModel,
      import12.DealModel,
      import0.ChangeDetectorRef
    ]
    ,{
      showCodeLink: [
        0,
        'showCodeLink'
      ]
      ,
      deal: [
        1,
        'deal'
      ]

    }
    ,{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    ck(v,1,0);
    ck(v,2,0);
    const currVal_8:any = true;
    const currVal_9:any = v.context.$implicit;
    ck(v,5,0,currVal_8,currVal_9);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'app-deal-',v.context.index,'');
    const currVal_1:any = import0.ɵnov(v,5).inlineAction;
    const currVal_2:any = import0.ɵnov(v,5).cornerAction;
    const currVal_3:any = import0.ɵnov(v,5).peelAction;
    const currVal_4:any = import0.ɵnov(v,5).bottomDescription;
    const currVal_5:any = import0.ɵnov(v,5).fadeOut;
    const currVal_6:any = import0.ɵnov(v,5).withAction;
    const currVal_7:any = import0.ɵnov(v,5).currentRestrictedOrderTypes;
    ck(v,4,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_DealsPageComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[
      [
        'class',
        'deals-deal'
      ]
      ,
      [
        'woa-element-width',
        ''
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(5455872,(null as any),0,import1.ElementWidthDirective,[
      import0.ElementRef,
      import0.ChangeDetectorRef,
      import2.ResponsiveService
    ]
    ,(null as any),(null as any)),
    import0.ɵdid(737280,(null as any),0,import3.ResponsiveDirective,[
      import0.ElementRef,
      import2.ResponsiveService,
      import4.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-promo-card',([] as any[]),[
      [
        2,
        'inlineAction',
        (null as any)
      ]
      ,
      [
        2,
        'cornerAction',
        (null as any)
      ]
      ,
      [
        2,
        'peelAction',
        (null as any)
      ]
      ,
      [
        2,
        'bottomDescription',
        (null as any)
      ]
      ,
      [
        2,
        'fadeOut',
        (null as any)
      ]
      ,
      [
        2,
        'withAction',
        (null as any)
      ]
      ,
      [
        2,
        'typeSpecific',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.promoActioned(v.context.$implicit,$event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import5.View_PromoCardComponent_0,import5.RenderType_PromoCardComponent)),
    import0.ɵdid(245760,(null as any),0,import6.PromoCardComponent,[
      import4.NavigationService,
      import7.AnalyticsService,
      import0.ElementRef,
      import8.TranslateService,
      import9.SessionModel,
      import10.MenuModel,
      import11.PromoModel,
      import12.DealModel,
      import0.ChangeDetectorRef
    ]
    ,{
      suppressProducts: [
        0,
        'suppressProducts'
      ]
      ,
      promo: [
        1,
        'promo'
      ]

    }
    ,{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    ck(v,1,0);
    ck(v,2,0);
    const currVal_7:any = false;
    const currVal_8:any = v.context.$implicit;
    ck(v,5,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,5).inlineAction;
    const currVal_1:any = import0.ɵnov(v,5).cornerAction;
    const currVal_2:any = import0.ɵnov(v,5).peelAction;
    const currVal_3:any = import0.ɵnov(v,5).bottomDescription;
    const currVal_4:any = import0.ɵnov(v,5).fadeOut;
    const currVal_5:any = import0.ɵnov(v,5).withAction;
    const currVal_6:any = import0.ɵnov(v,5).currentRestrictedOrderTypes;
    ck(v,4,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_DealsPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),20,'div',[
      [
        'class',
        'deals'
      ]
      ,
      [
        'woa-touchable',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(4210688,(null as any),0,import15.TouchableDirective,[import0.ElementRef],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DealsPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DealsPageComponent_3)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DealsPageComponent_4)),
    import0.ɵdid(802816,(null as any),0,import13.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DealsPageComponent_5)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DealsPageComponent_6)),
    import0.ɵdid(802816,(null as any),0,import13.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DealsPageComponent_7)),
    import0.ɵdid(802816,(null as any),0,import13.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.identityModel.promoteMemberLogin;
    ck(v,4,0,currVal_0);
    const currVal_1:any = co.memberDeals.length;
    ck(v,7,0,currVal_1);
    const currVal_2:any = co.memberDeals;
    ck(v,10,0,currVal_2);
    const currVal_3:any = ((co.appDeals.length || co.allUntriggeredCardPromos.length) && co.memberDeals.length);
    ck(v,13,0,currVal_3);
    const currVal_4:any = co.appDeals;
    ck(v,16,0,currVal_4);
    const currVal_5:any = co.allUntriggeredCardPromos;
    ck(v,19,0,currVal_5);
  },(null as any));
}
export function View_DealsPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'woa-modal-page-layout',([] as any[]),(null as any),[[
        (null as any),
        'onRefresh'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import16.DealsPageComponent = v.component;
      if (('onRefresh' === en)) {
        const pd_0:any = ((<any>co.loadMemberSummary()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import17.View_ModalPageLayoutComponent_0,import17.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import18.ModalPageLayoutComponent,[
      import19.Page,
      import4.NavigationService
    ]
    ,{
      showRefreshButton: [
        0,
        'showRefreshButton'
      ]
      ,
      showSubtitle: [
        1,
        'showSubtitle'
      ]
      ,
      title: [
        2,
        'title'
      ]
      ,
      subtitle: [
        3,
        'subtitle'
      ]
      ,
      translationParams: [
        4,
        'translationParams'
      ]

    }
    ,{onRefresh: 'onRefresh'}),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
    import0.ɵpod(['nrDeals']),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import19.PageLayout,(null as any),[import18.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_DealsPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import13.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),7,2,'woa-button',[[
        'woa-page-footer-control',
        ''
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import16.DealsPageComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,12).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.enterDealCode()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import20.View_ButtonComponent_0,import20.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import21.ButtonComponent,[
      import0.ElementRef,
      import9.SessionModel,
      import0.ChangeDetectorRef,
      import2.ResponsiveService
    ]
      ,{label: [
        0,
        'label'
      ]
    },(null as any)),
      import0.ɵdid(16384,[[
        3,
        4
      ]
    ],0,import22.PageFooterControlDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import16.DealsPageComponent = v.component;
    const currVal_0:any = true;
    const currVal_1:any = (co.status === co.LoadingStatus.LOADED);
    const currVal_2:any = 'woa.heading.deals.title';
    const currVal_3:any = ((co.nrDeals == 0)? 'woa.label.deals.noDeals': ((co.nrDeals == 1)? 'woa.label.deals.oneDeal': 'woa.label.deals.manyDeals'));
    const currVal_4:any = ck(v,5,0,co.nrDeals);
    ck(v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
    const currVal_5:any = (co.status === co.LoadingStatus.LOADED);
    ck(v,9,0,currVal_5);
    const currVal_33:any = 'woa.button.deals.enterDealCode';
    ck(v,12,0,currVal_33);
  },(ck,v) => {
    const currVal_6:any = import0.ɵnov(v,12).overrideFlatBackgroundColor;
    const currVal_7:any = import0.ɵnov(v,12).overrideFlatForegroundColor;
    const currVal_8:any = import0.ɵnov(v,12).overrideOutlineBackgroundColor;
    const currVal_9:any = import0.ɵnov(v,12).overrideOutlineForegroundColor;
    const currVal_10:any = import0.ɵnov(v,12).overrideOutlineBorderColor;
    const currVal_11:any = import0.ɵnov(v,12).overrideRaisedBackgroundColor;
    const currVal_12:any = import0.ɵnov(v,12).overrideRaisedForegroundColor;
    const currVal_13:any = import0.ɵnov(v,12).disabled;
    const currVal_14:any = import0.ɵnov(v,12).invisible;
    const currVal_15:any = import0.ɵnov(v,12).hovered;
    const currVal_16:any = import0.ɵnov(v,12).native;
    const currVal_17:any = import0.ɵnov(v,12).button;
    const currVal_18:any = import0.ɵnov(v,12).firstTier;
    const currVal_19:any = import0.ɵnov(v,12).secondTier;
    const currVal_20:any = import0.ɵnov(v,12).highProminence;
    const currVal_21:any = import0.ɵnov(v,12).lowProminence;
    const currVal_22:any = import0.ɵnov(v,12).affirmativeConnotation;
    const currVal_23:any = import0.ɵnov(v,12).dissuasiveConnotation;
    const currVal_24:any = import0.ɵnov(v,12).negativeConnotation;
    const currVal_25:any = import0.ɵnov(v,12).squareShape;
    const currVal_26:any = import0.ɵnov(v,12).roundedShape;
    const currVal_27:any = import0.ɵnov(v,12).ovalShape;
    const currVal_28:any = import0.ɵnov(v,12).flatStyle;
    const currVal_29:any = import0.ɵnov(v,12).outlineStyle;
    const currVal_30:any = import0.ɵnov(v,12).raisedStyle;
    const currVal_31:any = import0.ɵnov(v,12).verticalLayout;
    const currVal_32:any = import0.ɵnov(v,12).horizontalLayout;
    ck(v,11,1,[
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26,
      currVal_27,
      currVal_28,
      currVal_29,
      currVal_30,
      currVal_31,
      currVal_32
    ]
    );
  });
}
function View_DealsPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-deals-page',([] as any[]),(null as any),(null as any),(null as any),View_DealsPageComponent_0,RenderType_DealsPageComponent)),
    import0.ɵdid(114688,(null as any),0,import16.DealsPageComponent,[
      import23.OrderingContextModel,
      import24.IdentityModel,
      import12.DealModel,
      import4.NavigationService,
      import11.PromoModel,
      import25.AuthService,
      import8.TranslateService,
      import26.LoadingService,
      import27.NotificationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import19.Page,(null as any),[import16.DealsPageComponent])
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const DealsPageComponentNgFactory:import0.ComponentFactory<import16.DealsPageComponent> = import0.ɵccf('woa-deals-page',import16.DealsPageComponent,View_DealsPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/deal/deals-page/deals-page.component.ngfactory.ts